module.exports = __webpack_public_path__ + "static/img/slider-rev2.dae5a157.jpg";